import React, { useState, useEffect, useRef } from "react";
import styles from "./GalereyaOnboardingFaceRec.module.css";
import FaceRegistration from "../FaceRegistration/FaceRegistrationUpd";
import { ReactComponent as Logo } from "../../images/GN_logo.svg";

const GalereyaOnboarding = () => {
  const [employees, setEmployees] = useState([]);
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState("");
  const [feedback, setFeedback] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [showFaceRegistration, setShowFaceRegistration] = useState(false);
  const [faceImages, setFaceImages] = useState({
    front: null,
    left: null,
    right: null,
  });
  const searchRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [workType, setWorkType] = useState("");
  const [hybridOfflineDays, setHybridOfflineDays] = useState([]);
  const [hybridOnlineDays, setHybridOnlineDays] = useState([]);
  const [startWorkTime, setStartWorkTime] = useState("");
  const [endWorkTime, setEndWorkTime] = useState("");
  const [workDays, setWorkDays] = useState([]);
  const [popupType, setPopupType] = useState(""); // 'success' or 'error'
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showValidationErrors, setShowValidationErrors] = useState(false);

  const daysOfWeek = [
    { id: "Monday", label: "Понедельник" },
    { id: "Tuesday", label: "Вторник" },
    { id: "Wednesday", label: "Среда" },
    { id: "Thursday", label: "Четверг" },
    { id: "Friday", label: "Пятница" },
    { id: "Saturday", label: "Суббота" },
    { id: "Sunday", label: "Воскресенье" },
  ];

  const timeOptions = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const time = `${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
      timeOptions.push(time);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://5zbcsztftk.execute-api.eu-west-1.amazonaws.com/default/prod-user-list-api",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              sort_key: "glra12a4a6",
              data_type: "prefilled",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Ошибка при загрузке данных");
        }

        const data = await response.json();
        setOffices(data.office_list);
        setEmployees(data.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (searchTerm.length >= 3) {
      const filtered = employees.filter(
        (emp) =>
          emp.user_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          emp.user_surname.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredEmployees(filtered);
    } else {
      setFilteredEmployees([]);
      setSelectedEmployee(null);
    }
  }, [searchTerm, employees]);

  const handleEmployeeSelect = (employee) => {
    setSelectedEmployee(employee);
    setSearchTerm(`${employee.user_surname} ${employee.user_name}`);
    setFilteredEmployees([]);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    if (e.target.value === "") {
      setSelectedEmployee(null);
    }
  };

  const handleFaceRegistrationComplete = (images) => {
    setFaceImages(images);
    setShowFaceRegistration(false);
  };

  const handleWorkDayToggle = (day) => {
    setWorkDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleHybridOfflineDayToggle = (day) => {
    setHybridOfflineDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleHybridOnlineDayToggle = (day) => {
    setHybridOnlineDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  useEffect(() => {
    if (showValidationErrors && validateForm()) {
      setShowValidationErrors(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmployee, selectedOffice, workType, startWorkTime, endWorkTime, workDays, hybridOfflineDays, hybridOnlineDays, faceImages, showValidationErrors]);

  const validateForm = () => {
    if (
      !selectedEmployee ||
      !selectedOffice ||
      !workType ||
      !startWorkTime ||
      !endWorkTime
    ) {
      return false;
    }

    if (
      (workType === "оффлайн" || workType === "онлайн") &&
      workDays.length === 0
    ) {
      return false;
    }

    if (
      workType === "гибрид" &&
      (hybridOfflineDays.length === 0 || hybridOnlineDays.length === 0)
    ) {
      return false;
    }

    if (!faceImages.front) {
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent duplicate submissions

    if (!validateForm()) {
      setShowValidationErrors(true);
      setSubmissionStatus("Пожалуйста, заполните все обязательные поля (выделены красным)");
      setPopupType("error");
      setShowPopup(true);
      return;
    }

    const photoArray = [
      faceImages.front,
      faceImages.right,
      faceImages.left,
    ].filter((photo) => photo !== null);

    let workDaysPayload;
    if (workType === "гибрид") {
      workDaysPayload = {
        Offline: hybridOfflineDays,
        Online: hybridOnlineDays,
      };
    } else {
      workDaysPayload = {
        [workType === "онлайн" ? "Online" : "Offline"]: workDays,
      };
    }

    const payload = {
      place_id: "glra12a4a6",
      properties: {
        emp_department: selectedEmployee.emp_department,
        emp_unit: selectedEmployee.emp_unit,
        emp_subunit: selectedEmployee.emp_subunit,
        emp_position: selectedEmployee.emp_position,
        emp_category: "Сотрудник",
        user_gender: selectedEmployee.user_gender,
        emp_city: selectedEmployee.emp_city,
        emp_office: selectedOffice,
        user_feedback: feedback,
        work_type: workType,
        start_work_time: startWorkTime,
        end_work_time: endWorkTime,
        work_days: workDaysPayload,
      },
      user_name: selectedEmployee.user_name,
      user_surname: selectedEmployee.user_surname,
      data_url: photoArray,
    };

    setIsSubmitting(true);
    
    try {
      const response = await fetch(
        "https://ste1h7g7s7.execute-api.eu-west-1.amazonaws.com/LoyaltySystem1/UserRecords",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Ошибка при отправке данных");
      }

      const result = await response.json();
      setSubmissionStatus(
        `Успешно отправлено! Статус: ${
          result.user_status || "Данные сохранены"
        }`
      );
      setPopupType("success");
      setShowPopup(true);
    } catch (err) {
      setSubmissionStatus(`Ошибка: ${err.message}`);
      setPopupType("error");
      setShowPopup(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return <div className={styles.loading}>Загрузка данных...</div>;
  }

  if (error) {
    return <div className={styles.error}>Ошибка: {error}</div>;
  }

  if (showFaceRegistration) {
    return (
      <div className={styles.faceRegistrationContainer}>
        <FaceRegistration
          onComplete={handleFaceRegistrationComplete}
          onCancel={() => setShowFaceRegistration(false)}
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <Logo />
      </div>
      <h1 className={styles.title}>Регистрационная форма</h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <label htmlFor="employee">Сотрудник*</label>
          <div className={styles.searchContainer}>
            <input
              type="text"
              id="employee"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Введите имя или фамилию (минимум 3 символа)"
              className={`${styles.searchInput} ${showValidationErrors && !selectedEmployee ? styles.errorBorder : ""}`}
              ref={searchRef}
            />
            {filteredEmployees.length > 0 && (
              <ul className={styles.searchResults}>
                {filteredEmployees.map((emp, index) => (
                  <li
                    key={index}
                    onClick={() => handleEmployeeSelect(emp)}
                    className={styles.searchResultItem}
                  >
                    {emp.user_surname} {emp.user_name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {selectedEmployee && (
          <div className={styles.employeeInfo}>
            <h3>Информация о сотруднике</h3>
            <div className={styles.readOnlyField}>
              <label>Пол</label>
              <input
                type="text"
                value={
                  selectedEmployee.user_gender === "Male"
                    ? "Мужской"
                    : "Женский"
                }
                readOnly
              />
            </div>
            <div className={styles.readOnlyField}>
              <label>Город</label>
              <input type="text" value={selectedEmployee.emp_city} readOnly />
            </div>
            <div className={styles.readOnlyField}>
              <label>Департамент</label>
              <input
                type="text"
                value={selectedEmployee.emp_department}
                readOnly
              />
            </div>
            <div className={styles.readOnlyField}>
              <label>Отдел</label>
              <input type="text" value={selectedEmployee.emp_unit} readOnly />
            </div>
            <div className={styles.readOnlyField}>
              <label>Подразделение</label>
              <input
                type="text"
                value={selectedEmployee.emp_subunit.join(", ")}
                readOnly
              />
            </div>
            <div className={styles.readOnlyField}>
              <label>Должность</label>
              <input
                type="text"
                value={selectedEmployee.emp_position}
                readOnly
              />
            </div>
          </div>
        )}

        <div className={styles.formGroup}>
          <label htmlFor="office">Офис*</label>
          <select
            id="office"
            value={selectedOffice}
            onChange={(e) => setSelectedOffice(e.target.value)}
            className={`${styles.select} ${showValidationErrors && !selectedOffice ? styles.errorBorder : ""}`}
          >
            <option value="">Выберите офис</option>
            {offices.map((office, index) => (
              <option key={index} value={office}>
                {office}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="workType">График работы*</label>
          <select
            id="workType"
            value={workType}
            onChange={(e) => {
              setWorkType(e.target.value);
              setWorkDays([]);
              setHybridOfflineDays([]);
              setHybridOnlineDays([]);
              setStartWorkTime("");
              setEndWorkTime("");
            }}
            className={`${styles.select} ${showValidationErrors && !workType ? styles.errorBorder : ""}`}
          >
            <option value="">Выберите график работы</option>
            <option value="2/2">2/2</option>
            <option value="3/3">3/3</option>
            <option value="оффлайн">Оффлайн</option>
            <option value="онлайн">Онлайн</option>
            <option value="гибрид">Гибрид</option>
          </select>
        </div>

        {(workType === "2/2" ||
          workType === "3/3" ||
          workType === "оффлайн" ||
          workType === "онлайн" ||
          workType === "гибрид") && (
          <div className={styles.formGroup}>
            <label>Рабочее время*</label>
            <div className={styles.timeInputContainer}>
              <select
                value={startWorkTime}
                onChange={(e) => setStartWorkTime(e.target.value)}
                className={`${styles.timeInput} ${showValidationErrors && !startWorkTime ? styles.errorBorder : ""}`}
              >
                <option value="">Начало</option>
                {timeOptions.map((time) => (
                  <option key={time} value={time}>
                    {time}
                  </option>
                ))}
              </select>
              <span className={styles.timeSeparator}>—</span>
              <select
                value={endWorkTime}
                onChange={(e) => setEndWorkTime(e.target.value)}
                className={`${styles.timeInput} ${showValidationErrors && !endWorkTime ? styles.errorBorder : ""}`}
              >
                <option value="">Конец</option>
                {timeOptions.map((time) => (
                  <option key={time} value={time}>
                    {time}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {workType === "оффлайн" && (
          <div className={styles.formGroup}>
            <label className={showValidationErrors && workDays.length === 0 ? styles.errorText : ""}>Рабочие дни (оффлайн)*</label>
            <div className={styles.daysContainer}>
              {daysOfWeek.map((day) => (
                <div key={day.id} className={styles.dayCheckbox}>
                  <input
                    type="checkbox"
                    id={`offline-${day.id}`}
                    checked={workDays.includes(day.id)}
                    onChange={() => handleWorkDayToggle(day.id)}
                  />
                  <label htmlFor={`offline-${day.id}`}>{day.label}</label>
                </div>
              ))}
            </div>
          </div>
        )}

        {workType === "онлайн" && (
          <div className={styles.formGroup}>
            <label className={showValidationErrors && workDays.length === 0 ? styles.errorText : ""}>Рабочие дни (онлайн)*</label>
            <div className={styles.daysContainer}>
              {daysOfWeek.map((day) => (
                <div key={day.id} className={styles.dayCheckbox}>
                  <input
                    type="checkbox"
                    id={`online-${day.id}`}
                    checked={workDays.includes(day.id)}
                    onChange={() => handleWorkDayToggle(day.id)}
                  />
                  <label htmlFor={`online-${day.id}`}>{day.label}</label>
                </div>
              ))}
            </div>
          </div>
        )}

        {workType === "гибрид" && (
          <>
            <div className={styles.formGroup}>
              <label className={showValidationErrors && hybridOfflineDays.length === 0 ? styles.errorText : ""}>Рабочие дни (оффлайн)*</label>
              <div className={styles.daysContainer}>
                {daysOfWeek.map((day) => (
                  <div key={`offline-${day.id}`} className={styles.dayCheckbox}>
                    <input
                      type="checkbox"
                      id={`hybrid-offline-${day.id}`}
                      checked={hybridOfflineDays.includes(day.id)}
                      onChange={() => handleHybridOfflineDayToggle(day.id)}
                    />
                    <label htmlFor={`hybrid-offline-${day.id}`}>
                      {day.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.formGroup}>
              <label className={showValidationErrors && hybridOnlineDays.length === 0 ? styles.errorText : ""}>Рабочие дни (онлайн)*</label>
              <div className={styles.daysContainer}>
                {daysOfWeek.map((day) => (
                  <div key={`online-${day.id}`} className={styles.dayCheckbox}>
                    <input
                      type="checkbox"
                      id={`hybrid-online-${day.id}`}
                      checked={hybridOnlineDays.includes(day.id)}
                      onChange={() => handleHybridOnlineDayToggle(day.id)}
                    />
                    <label htmlFor={`hybrid-online-${day.id}`}>
                      {day.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        <div className={styles.photoSection}>
          <h3 className={showValidationErrors && !faceImages.front ? styles.errorText : ""}>Фотографии*</h3>
          <button
            type="button"
            onClick={() => setShowFaceRegistration(true)}
            className={`${styles.faceRegistrationButton} ${showValidationErrors && !faceImages.front ? styles.errorBorder : ""}`}
          >
            Зарегистрировать лицо
          </button>

          {faceImages.front && (
            <div className={styles.faceImagesPreview}>
              <div className={styles.faceImageContainer}>
                <img
                  src={faceImages.front}
                  alt="Front"
                  className={styles.faceImage}
                />
                <span>Фронтальное</span>
              </div>
              {faceImages.left && (
                <div className={styles.faceImageContainer}>
                  <img
                    src={faceImages.left}
                    alt="Left"
                    className={styles.faceImage}
                  />
                  <span>Левая сторона</span>
                </div>
              )}
              {faceImages.right && (
                <div className={styles.faceImageContainer}>
                  <img
                    src={faceImages.right}
                    alt="Right"
                    className={styles.faceImage}
                  />
                  <span>Правая сторона</span>
                </div>
              )}
            </div>
          )}
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="feedback">Обратная связь (макс. 200 символов)</label>
          <textarea
            id="feedback"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value.slice(0, 200))}
            maxLength={200}
            className={styles.textarea}
            placeholder="Ваш отзыв или комментарий"
          />
          <div className={styles.charCount}>{feedback.length}/200</div>
        </div>

        <button
          type="submit"
          className={styles.submitButton}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Отправка..." : "Отправить"}
        </button>
      </form>

      {showPopup && (
        <div className={styles.popupOverlay}>
          <div
            className={`${styles.popup} ${
              popupType === "success" ? styles.successPopup : styles.errorPopup
            }`}
          >
            <div className={styles.popupContent}>
              <div className={styles.popupIcon}>
                {popupType === "success" ? "✓" : "!"}
              </div>
              <h3>{popupType === "success" ? "Успешно!" : "Ошибка"}</h3>
              <p>{submissionStatus}</p>
              <button
                onClick={() => {
                  setShowPopup(false);
                  if (popupType === "success") {
                    setShowValidationErrors(false);
                    setSelectedEmployee(null);
                    setSelectedOffice("");
                    setFeedback("");
                    setFaceImages({ front: null, left: null, right: null });
                    setSearchTerm("");
                    setWorkType("");
                    setStartWorkTime("");
                    setEndWorkTime("");
                    setWorkDays([]);
                    setHybridOfflineDays([]);
                    setHybridOnlineDays([]);
                  }
                }}
                className={`${styles.popupButton} ${
                  popupType === "success"
                    ? styles.successButton
                    : styles.errorButton
                }`}
              >
                Закрыть
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalereyaOnboarding;
